import { howSteps } from "@/mocks/homeData";

export default function HowItWorks() {
  return (
    <section id="how" className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
      <div className="grid items-center gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-800">
            <i className="ri-settings-5-line"></i>
            公开透明的榜单机制
          </span>
          <h3 className="mt-5 font-heading text-2xl font-extrabold leading-snug tracking-tight text-foreground-950 md:text-4xl">
            吃瓜王榜单，<br />
            是这样一步步算出来的
          </h3>
          <p className="mt-4 text-sm leading-6 text-foreground-600 md:text-base">
            不靠编辑拍脑袋，也不靠平台悄悄改权重。每一份吃瓜王排行榜都来自
            对公开讨论的量化统计，谁火谁凉，数字说话。
          </p>
          <a
            href="#rank"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-foreground-900 bg-foreground-950 px-5 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-foreground-800"
          >
            看看今日实时数据
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <ol className="space-y-4">
          {howSteps.map((s, i) => (
            <li
              key={s.no}
              className="relative flex gap-5 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300 md:p-6"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-500 text-background-50">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <div>
                <div className="flex items-center gap-3">
                  <span className="font-num text-lg text-secondary-700">{s.no}</span>
                  <h4 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{s.title}</h4>
                </div>
                <p className="mt-2 text-sm leading-6 text-foreground-500">{s.desc}</p>
              </div>
              {i < howSteps.length - 1 && (
                <i className="absolute -bottom-5 left-8 z-10 hidden text-background-400 lg:block ri-corner-down-right-line"></i>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}